import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, httpResource } from '@angular/common/http';
import { Job } from '../../models/job.model';
import { Traineeship } from '../../models/traineeship.model';

const baseUrl = environment.apiBaseUrl;

@Injectable({
  providedIn: 'root',
})
export class JobsService {
  private readonly http = inject(HttpClient);

  jobs = httpResource<Job[]>(() => `${baseUrl}/public/jobs`);

  traineeships = httpResource<Traineeship[]>(() => `${baseUrl}/public/internships`);
}
